import { Tag } from './tag';

export interface ImageThumbnails {
  lg?: string;
  md?: string;
  sm?: string;
}

export interface ImageEntity {
  id: string;
  url: string;
  title: string;
  link: string;
  thumbnails: ImageThumbnails;
  tags: Tag[];
  status: string;
}

export enum ImageStatus {
  ACTIVE = 'active',
  DELETED = 'deleted',
}

export const isImageEntity = (img: any): img is ImageEntity => {
  return !!(img && img.url);
};
